// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"179":"2fb7c129","234":"be029334"}[chunkId] + ".js";
};